(() => {
  'use strict';

  if (window.ShrineHeaderSearchCloseFix) return;
  window.ShrineHeaderSearchCloseFix = true;

  const lockClasses = [
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'overflow-hidden-desktop'
  ];

  const unlockPageWhenSafe = () => {
    const anotherOverlayIsOpen = document.querySelector(
      'details-modal details[open], header-drawer details[open], cart-drawer.active, .menu-opening'
    );

    if (anotherOverlayIsOpen) return;

    lockClasses.forEach((className) => {
      document.body.classList.remove(className);
      document.documentElement.classList.remove(className);
    });
  };

  const closeHeaderSearch = (source, restoreFocus = true) => {
    if (!(source instanceof Element)) return;

    const searchRoot = source.closest('.header__search');
    if (!searchRoot) return;

    const detailsModal = searchRoot.matches('details-modal')
      ? searchRoot
      : searchRoot.closest('details-modal');
    const details = searchRoot.querySelector('details') || source.closest('details');
    const summary = details ? details.querySelector(':scope > summary') : null;

    if (detailsModal && typeof detailsModal.close === 'function') {
      try {
        detailsModal.close(false);
      } catch (error) {
        // The explicit details cleanup below remains the reliable fallback.
      }
    }

    if (details) {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    }

    if (summary) summary.setAttribute('aria-expanded', 'false');

    searchRoot.querySelectorAll('predictive-search').forEach((predictiveSearch) => {
      predictiveSearch.removeAttribute('open');
      predictiveSearch.removeAttribute('loading');
      predictiveSearch.isOpen = false;
    });

    searchRoot.querySelectorAll('.search__input[aria-expanded]').forEach((input) => {
      input.setAttribute('aria-expanded', 'false');
    });

    window.requestAnimationFrame(unlockPageWhenSafe);

    if (restoreFocus && summary) {
      window.setTimeout(() => summary.focus({ preventScroll: true }), 0);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const closeControl = event.target.closest(
        '.header__search .modal__close-button, ' +
          '.header__search .search-modal__close-button, ' +
          '.header__search .modal-overlay'
      );

      if (!closeControl) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      closeHeaderSearch(closeControl);
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Escape') return;

      const openSearch = document.querySelector('.header__search details[open]');
      if (!openSearch) return;

      event.preventDefault();
      closeHeaderSearch(openSearch);
    },
    true
  );
})();
